import React, { useState, useEffect } from "react";
import { Popover, Button, TextField, Box } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { Column, ColumnFiltersState } from "@tanstack/react-table";
import { CustomColumnDef } from "./UserTable";
import { autocompleteDropdownStyles } from "Constants/Style";
import { Axios } from "api/axios";
import { fetchPackages } from "slices/package/thunk";
import { toast } from "react-toastify";

interface FilterPopoverProps<TData> {
  column: Column<TData, unknown>;
  columnDef: CustomColumnDef<TData>;
  columnFilters?: ColumnFiltersState;
  setColumnFilters?: React.Dispatch<React.SetStateAction<ColumnFiltersState>>;
  setColValue?: any;
  iconColor?: string;
}

const OrganisationsFilterPopover = ({
  column,
  columnDef,
  columnFilters,
  setColumnFilters,
  setColValue,
  iconColor,
}: FilterPopoverProps<any>) => {
  const filterType = columnDef.filterType;

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [tempValue, setTempValue] = useState(column?.getFilterValue() || "");
  const [name, setName] = useState<string>("name");

  const [options, setOptions] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  const open = Boolean(anchorEl);

  const handleOpen = (e: React.MouseEvent<Element>) => {
    setAnchorEl(e.currentTarget as HTMLElement);
  };

  const handleClose = () => {
    // setAnchorEl(null);

    // column.setFilterValue(undefined); // or `null` also works

    // if (setColValue) {
    //   setColValue((prev: any) =>
    //     (prev || []).filter(
    //       (f: { filterField: string }) => f.filterField !== column.id
    //     )
    //   );
    // }

    // setTempValue("");
    setAnchorEl(null);
  };

  const handleApply = () => {
    if (setColValue) {
      column.setFilterValue(tempValue);
      setColValue((prev: any) => {
        const updated = (prev || []).filter(
          (f: { filterField: string }) => f.filterField !== column.id
        );
        return [...updated, { filterField: column.id, filterValue: tempValue }];
      });
    }
    setAnchorEl(null);
  };

  const handleClear = () => {
    // Clear the filter from the table column
    column.setFilterValue(undefined);

    // Remove it from your local filter state
    if (setColValue) {
      setColValue((prev: any) =>
        (prev || []).filter(
          (f: { filterField: string }) => f.filterField !== column.id
        )
      );
    }

    // Clear the input value
    setTempValue("");
  };

  useEffect(() => {
    const appliedFilter = column.getFilterValue();
  }, []);
useEffect(() => {
  if (open && columnDef.filterFetchUrl) {
    const fetchOptions = async () => {
      setLoading(true);
      try {
        const response = await Axios.get(columnDef.filterFetchUrl || "");
        const data: any = response.data;

        console.log("data in dropdown: ", data);

        const values =
  data[column.id] ||              
  data[`department__${column.id}`] || 
  data[`organization__${column.id}`] || 
  data[`team__${column.id}`] ||   
  data.values ||                 
  [];

        setOptions(values);
      } catch (error) {
        toast.error("Failed to fetch filter options");
        console.error("Failed to fetch filter options:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchOptions();

    if (open) {
      const appliedFilter = column.getFilterValue();
      setTempValue(appliedFilter || "");
    }
  }
}, [open, columnDef.filterFetchUrl]);


  return (
    <>
      <FilterAltIcon
        fontSize="small"
        onClick={handleOpen}
        style={{ cursor: "pointer", marginLeft: 6, color: iconColor}}
      />

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Box p={2} width={200} sx={{ fontFamily: 'Poppins, sans-serif' }}>
          {filterType === "dropdown" ? (
            <Autocomplete
              sx={{ width: "100%", textTransform: "capitalize" }}
              size="small"
              id="filter-autocomplete"
              options={options || []}
              value={options?.find((opt) => opt === tempValue) ?? null}
              getOptionLabel={(option: any) => option?.toString()}
              isOptionEqualToValue={(option: any, value: any) =>
                option === value
              }
              ListboxProps={autocompleteDropdownStyles.ListboxProps}
              renderOption={(props, option: any) => {
                const { key, ...rest } = props;
                return (
                  <Box
                    key={key}
                    component="li"
                    {...rest}
                    style={{
                      fontFamily: 'Poppins, sans-serif',
                      fontSize: '13px',
                    }}
                  >
                    {option?.toString()}
                  </Box>
                );
              }}
              onChange={(_, newValue) => {
                setTempValue(newValue ?? "");
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  label="Select"
                  sx={{
                    ...autocompleteDropdownStyles.inputSx,
                    '& .MuiInputLabel-root': {
                      fontFamily: 'Poppins, sans-serif',
                      fontSize: '13px',
                    },
                    '& .MuiFormHelperText-root': {
                      fontFamily: 'Poppins, sans-serif',
                      fontSize: '13px',
                    },
                  }}
                />
              )}
            />
          ) : (
            <TextField
              fullWidth
              label="Search"
              value={tempValue}
              onChange={(e) => setTempValue(e.target.value)}
              size="small"
              sx={{
                fontFamily: 'Poppins, sans-serif',
                '& input': {
                  fontFamily: 'Poppins, sans-serif',
                  fontSize: '13px',
                },
                '& .MuiInputLabel-root': {
                  fontFamily: 'Poppins, sans-serif',
                  fontSize: '13px',
                },
                '& .MuiFormHelperText-root': {
                  fontFamily: 'Poppins, sans-serif',
                  fontSize: '13px',
                },
              }}
            />
          )}

          <Box mt={2} display="flex" justifyContent="flex-end" gap={1}>
            <Button
              className="btn btn-secondary"
              size="small"
              variant="outlined"
              onClick={handleClear}
              sx={{ fontFamily: 'Poppins, sans-serif', fontSize: '13px' }}
            >
              Cancel
            </Button>
            <Button
              className="btn btn-primary"
              size="small"
              variant="contained"
              onClick={handleApply}
              sx={{ fontFamily: 'Poppins, sans-serif', fontSize: '13px' }}
            >
              Apply
            </Button>
          </Box>
        </Box>
      </Popover>
    </>
  );
};

export default OrganisationsFilterPopover;
